export const ELIGIBILITY_CHECK_SLICE_NAME = 'eligibility-check';

export interface EligibilityCheckState {
  memberBigN: {
    firstName: string;
    lastName: string;
    birthDate: string;
  };
}

export interface EligibilityCheckOwnState {
  [ELIGIBILITY_CHECK_SLICE_NAME]: EligibilityCheckState;
}
